import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const reviews = [
  {
    name: "Leanne Thomas",
    date: "14 February 2026",
    rating: 5,
    text: "Very professional company. The cleaners are well trained and very accommodating. Katherine is the best cleaner I have ever had.",
    initial: "L",
    bgColor: "#7a92a3",
  },
  {
    name: "janet galbraith",
    date: "14 February 2026",
    rating: 5,
    text: "Binoy was back and did a beautiful job, thorough, efficient, punctual and friendly. Highly recommend!",
    initial: "j",
    bgColor: "#004d40",
  },
  {
    name: "Amy Fitzgerald",
    date: "13 February 2026",
    rating: 5,
    text: "Alex was polite, punctual and did an outstanding job! The house looks amazing.",
    initial: "A",
    bgColor: "#9c27b0",
  },
  {
    name: "Sandi Banks",
    date: "13 February 2026",
    rating: 5,
    text: "I'm very happy with Kangaroo Shine so far. The cleaners they have sent me are friendly, polite and professional.",
    initial: "S",
    bgColor: "#e91e63",
  },
  {
    name: "John Smith",
    date: "10 February 2026",
    rating: 5,
    text: "Excellent service! They were thorough and professional. My office has never looked better.",
    initial: "J",
    bgColor: "#1a237e",
  },
];

class GoogleReviews extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    return (
      <div className="google-reviews-section p-tb50">
        <div className="container">
          {/* Google Review Header */}
          <div className="google-header-bar mb-4">
            <div className="google-info">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                alt="Google"
                className="google-logo"
              />
              <span className="rating-status">Excellent</span>
              <div className="header-stars">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <span className="rating-score">4.8 | 1906 reviews</span>
            </div>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="write-review-btn"
            >
              Write a review
            </a>
          </div>

          {/* Reviews Carousel */}
          <Slider {...settings} className="google-reviews-slider">
            {reviews.map((item, index) => (
              <div className="item px-2" key={index}>
                <div className="google-review-card h-100">
                  <div className="card-header-flex">
                    <div
                      className="user-avatar"
                      style={{ backgroundColor: item.bgColor }}
                    >
                      {item.initial}
                    </div>
                    <div className="user-meta">
                      <h6 className="user-name">{item.name}</h6>
                      <span className="review-date">{item.date}</span>
                    </div>
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg"
                      alt="G"
                      className="g-icon"
                    />
                  </div>
                  <div className="review-stars-small">
                    {[...Array(item.rating)].map((_, i) => (
                      <i key={i} className="fa fa-star"></i>
                    ))}
                  </div>
                  <p className="review-text">{item.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default GoogleReviews;
